"use client";
import { useRouter } from "next/navigation";
import { CookiePolicyPage } from "@/components/cookie-policy/CookiePolicyPage";

export default function CookiePolicy() {
  const router = useRouter();
  return <CookiePolicyPage onBackToHome={() => router.push("/")} />;
}
